import service from 'service';

export const getUsers = ({ queryKey: [, params] }) => {
  const url = `/acl/user?sort[id]=desc`;
  return service.get(url, { params });
};

export const getUserById = ({ queryKey: [, id] }) => {
  const url = `/acl/user/${id}`;
  return service.get(url);
};

export const addUser = (payload) => {
  const url = '/acl/user/admin_profile';
  return service.post(url, payload);
};

export const editUser = ({ id, email }) => {
  const url = `/acl/user/${id}`;
  return service.put(url, { email });
};

export const editAdminProfile = ({ id, ...payload }) => {
  const url = `/acl/user/${id}/admin_profile`;
  return service.put(url, payload);
};
export const editStatus = ({ id }) => {
  const url = `/acl/user/${id}/change_status`;
  return service.put(url);
};

export const deleteUser = ({ id, ...payload }) => {
  const url = `/acl/user/${id}`;
  return service.delete(url, { data: payload });
};

export const resetPass = ({ id, ...payload }) => {
  const url = `/acl/user/${id}/change_password`;
  return service.put(url, payload);
};

export default {};
